// Build the grouped recipient dropdown options for VueEmail.
//
// vue-multiselect 2.1.9 can't use native grouping (`group-values`) together with
// `taggable` (the "press enter to add email" behaviour we must keep), so sections
// are rendered as non-selectable HEADER MARKER rows injected into a flat option
// list. The option slot branches on `$isLabel` to render a header vs a normal row,
// and the selection watchers strip any `$isLabel` marker so it never becomes a chip.
//
// Sections, in order (each omitted when empty):
//   QUOTE CONTACTS  — this quote's own customer/insurer (contact.sort === 0)
//   RECENT          — previously-sent addresses (deduped vs contacts, capped)
//   ALL CONTACTS    — the rest of the company directory (contact.sort !== 0)

function header(groupLabel, key) {
  return { $isLabel: true, groupLabel, email: `__hdr_${key}__`, name: groupLabel }
}

// Recent items matching the query, excluding any address already present as a
// saved contact (contact takes precedence), de-duped and capped.
function filterRecent(recents, contactEmails, query, limit) {
  const q = (query || '').trim().toLowerCase()
  const seen = new Set()
  const matches = []
  for (const r of recents) {
    if (!r || !r.email) continue
    const email = r.email.toLowerCase()
    if (contactEmails.has(email) || seen.has(email)) continue
    if (q) {
      const name = (r.name || '').toLowerCase()
      if (!email.includes(q) && !name.includes(q)) continue
    }
    seen.add(email)
    matches.push(r)
    if (matches.length >= limit) break
  }
  return matches
}

export function buildRecipientOptions(contacts, recent, query, recentLimit = 3) {
  const list = Array.isArray(contacts) ? contacts : []
  const recents = Array.isArray(recent) ? recent : []

  const quoteContacts = list.filter((c) => c && c.sort === 0)
  const allContacts = list.filter((c) => c && c.sort !== 0)

  const contactEmails = new Set(
    list.map((c) => (c && c.email ? c.email.toLowerCase() : null)).filter(Boolean)
  )
  const recentMatches = filterRecent(recents, contactEmails, query, recentLimit)

  const options = []
  if (quoteContacts.length) {
    options.push(header('QUOTE CONTACTS', 'quote'), ...quoteContacts)
  }
  if (recentMatches.length) {
    options.push(header('RECENT', 'recent'), ...recentMatches)
  }
  if (allContacts.length) {
    options.push(header('ALL CONTACTS', 'all'), ...allContacts)
  }
  return options
}

export default buildRecipientOptions
